import { render, staticRenderFns } from "./gateway-limits-settings.vue?vue&type=template&id=f3ad7f8c"
import script from "./gateway-limits-settings.vue?vue&type=script&lang=js"
export * from "./gateway-limits-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports